export const INTERNAL_LINKS = {
  LP: {
    LINK: 'https://corp.up-sider.com/',
  },
  IE: {
    LINK: 'https://up-sider.com/ie',
  },
  PRESIDENT: {
    PRIVACY_POLICY: 'https://president-card.com/privacy-policy',
    TERMS: 'https://president-card.com/terms',
  },
  ALL_SERVICE_TERMS: 'https://landingpage.up-sider.com/all-service-terms',
}
